import { render, staticRenderFns } from "./cpWidget.vue?vue&type=template&id=203084ef"
import script from "./cpWidget.vue?vue&type=script&lang=js"
export * from "./cpWidget.vue?vue&type=script&lang=js"
import style0 from "./cpWidget.vue?vue&type=style&index=0&id=203084ef&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203084ef')) {
      api.createRecord('203084ef', component.options)
    } else {
      api.reload('203084ef', component.options)
    }
    module.hot.accept("./cpWidget.vue?vue&type=template&id=203084ef", function () {
      api.rerender('203084ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cpWidget/cpWidget.vue"
export default component.exports